
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

interface PlayersTabProps {
  data: {
    tracking: {
      count: number;
      formation: string;
      formationChanges: Array<{
        timestamp: string;
        formation: string;
      }>;
      positions: Array<{
        id: number;
        distanceCovered: number;
        topSpeed: number;
      }>;
    };
    statistics: {
      passAccuracy: {
        team1: string;
        team2: string;
      };
      shots: {
        team1: {
          onTarget: number;
          offTarget: number;
          blocked: number;
        };
        team2: {
          onTarget: number;
          offTarget: number;
          blocked: number;
        };
      };
    };
  };
}

const PlayersTab: React.FC<PlayersTabProps> = ({ data }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Player Tracking</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div>
              <span className="font-medium">Players detected:</span> {data.tracking.count}
            </div>
            <div>
              <span className="font-medium">Formation:</span> {data.tracking.formation}
            </div>
            <div>
              <span className="font-medium">Formation Changes:</span>
              <ul className="mt-1 space-y-1 text-sm">
                {data.tracking.formationChanges.map((change, index) => (
                  <li key={index}>
                    {change.timestamp}: {change.formation}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <span className="font-medium">Top Performers:</span>
              <ul className="mt-1 space-y-1 text-sm">
                {data.tracking.positions.map((player) => (
                  <li key={player.id}>
                    Player {player.id} - {player.distanceCovered}km, {player.topSpeed} km/h
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-base">Player Statistics</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            <div>
              <span className="font-medium">Pass Accuracy:</span>
              <div className="mt-1 grid grid-cols-2 gap-2 text-sm">
                <div className="bg-blue-50 p-2 rounded">
                  Team 1: {data.statistics.passAccuracy.team1}
                </div>
                <div className="bg-red-50 p-2 rounded">
                  Team 2: {data.statistics.passAccuracy.team2}
                </div>
              </div>
            </div>
            <Separator />
            <div>
              <span className="font-medium">Shots:</span>
              <div className="mt-1 grid grid-cols-2 gap-2 text-sm">
                <div className="space-y-1">
                  <p className="font-medium">Team 1</p>
                  <p>On Target: {data.statistics.shots.team1.onTarget}</p>
                  <p>Off Target: {data.statistics.shots.team1.offTarget}</p>
                  <p>Blocked: {data.statistics.shots.team1.blocked}</p>
                </div>
                <div className="space-y-1">
                  <p className="font-medium">Team 2</p>
                  <p>On Target: {data.statistics.shots.team2.onTarget}</p>
                  <p>Off Target: {data.statistics.shots.team2.offTarget}</p>
                  <p>Blocked: {data.statistics.shots.team2.blocked}</p>
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PlayersTab;
